import { IconPropsType } from "../../types";

const CalendarPlus = (props: IconPropsType) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" className={props.additionalStyle}>
            <path d="M18 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V7C20 6.46957 19.7893 5.96086 19.4142 5.58579C19.0391 5.21071 18.5304 5 18 5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 3V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 3V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4 11H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 16H14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 14V18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default CalendarPlus;
